module.exports = __webpack_public_path__ + "static/media/image74.0b5427f5.png";